import * as React from 'react';
import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function CircularProgressWithLabel(
    props: CircularProgressProps & { placeholder: string }
) {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            <CircularProgress
                variant="determinate"
                {...props}
                title="progress loading"
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                >
                    {
                        // eslint-disable-next-line react/destructuring-assignment
                        props.placeholder
                    }
                </Typography>
            </Box>
        </Box>
    );
}
